module.exports = __webpack_public_path__ + "img/IP-BID.com.23d80468.svg";